// Form is based on Formik
// Data validation is based on Yup
// Please, be familiar with article first:
// https://hackernoon.com/react-form-validation-with-formik-and-yup-8b76bda62e10
import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import { Input, SearchSelect as Select, prepareOptions } from "../../../_metronic/_partials/controls";
import * as _reg from "../CatalogRegions/operations";
import { states } from "../CatalogLocations/state"
const CustomerEditSchema = Yup.object().shape({
  name: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Field is neccesary"),
  phone: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Field is neccesary"),
  address: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Field is neccesary"),
  work_type: Yup.string().optional(),
  password: Yup.string()
    .min(6, "Minimum 6 symbols")
    .max(50, "Maximum 50 symbols")
    .optional("Field is neccesary"),
  email: Yup.string()
    .email()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Field is neccesary")
  // company_name: Yup.string()
  //   .min(3, "Minimum 3 symbols")
  //   .max(50, "Maximum 50 symbols")
  //   .required("Field is neccesary"),
});
/* const AVAILABLE_LOCATIONS = ["--null--", "Arizona", "Texas"]; */
export function ClientEditForm({
  update,
  client,
  actionsLoading,
  handleClose,
}) {
  const [regions, setRegions] = useState([])
  useEffect(() => {
    _reg.getClients(setRegions)

  }, []);
  const [isSubmitting, setSubmitting] = useState(false)

  const toInputUppercase = e => {
    e.target.value = ("" + e.target.value).toUpperCase();
  };
  return (

    <>
      <Formik
        enableReinitialize={true}
        validateOnChange={false}
        validateOnBlur={false}
        initialValues={{
          work_type: "event",
          work_state: "Alabama",
          ...client
        }}
        validationSchema={CustomerEditSchema}
        onSubmit={(values) => {
          update({ ...client, ...values })
            .then(() => setSubmitting(false))
            .end((err) => {
              setSubmitting(false)
            })
        }}
      >
        {({ handleSubmit, handleChange, errors, values }) => (
          <>
            <Modal.Body className="  cursor-default">
              {actionsLoading && (
                <div className="overlay-layer bg-transparent">
                  <div className="spinner spinner-lg spinner-success" />
                </div>
              )}
              <div className="form form-label-right">
                <div className="form-group row">
                  {/* First Name */}
                  <div className="col-lg-4">
                    <Field
                      name="name"
                      component={Input}
                      placeholder="Name"
                      label="Name"
                      onInput={toInputUppercase}
                      errors={errors}
                      handleChange={handleChange}
                    />
                  </div>
                  {/* Last Name */}
                  <div className="col-lg-4">
                    <Field
                      name="phone"
                      component={Input}
                      placeholder="Phone"
                      label="Phone"
                      onInput={toInputUppercase}
                      errors={errors}
                      handleChange={handleChange}
                    />
                  </div>
                  {/* Login */}
                  <div className="col-lg-4">
                    <Field
                      type="text"
                      name="address"
                      component={Input}
                      placeholder="address"
                      label="address"
                      onInput={toInputUppercase}
                      errors={errors}
                      handleChange={handleChange}
                    />
                  </div>
                </div>
                {/* Email */}
                <div className="form-group row">
                  <div className="col-lg-4">
                    <Field
                      type="email"
                      name="email"
                      disabled={client.uid}
                      component={Input}
                      placeholder="Email"
                      label="Email"
                      errors={errors}
                      handleChange={handleChange}
                    />
                  </div>
                  <div className="col-lg-4">
                    <Field
                      type="password"
                      name="password"
                      errors={errors}
                      handleChange={handleChange}
                      component={Input}
                      disabled={client.uid}
                      placeholder="password"
                      label="password"
                    />
                  </div>
                  {/* <Select name="company_name" label="Company">
                            <option value="--null--">--null--</option>
                            {AVAILABLE_MANUFACTURES.map((manufacture) => (
                              <option
                                key={manufacture.uid}
                                value={manufacture.name}
                              >
                                {manufacture.name}
                              </option>
                            ))}
                          </Select> */}
                </div>
                <hr />
                <h6 className="text-muted">Work Specifications</h6>
                <div className="form-group row">
                  <div className="col-lg-4">
                    <Select
                      name="work_type"
                      label="type"
                      options={prepareOptions("upper", "name", ["event", "service"].map(s => ({
                        upper: s.toUpperCase(),
                        name: s
                      })))}
                    >

                    </Select>
                  </div>
                  {values.type === "event" ? (null) : (
                    <>
                      <div className="col-lg-4">
                        <Select
                          name="work_state"
                          label="state"
                          options={prepareOptions("name", "uid", Object.keys(states).sort(function (a, b) {
                            if (a < b) { return -1; }
                            if (a > b) { return 1; }
                            return 0;
                          }))}

                        >
               
                        </Select>
                      </div>
                      <div className="col-lg-4">
                        <Select
                          name="work_region"
                          label="region"
                          options={prepareOptions("name", "uid", regions.filter(region => region.state === values.work_state))}

                        >
                        </Select>

                      </div>

                    </>
                  )}
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                onClick={handleClose}
                className="btn btn-light btn-elevate"
              >
                Cancel
                    </button>
              <> </>
              <button
                onClick={() => {
                  setSubmitting(true)
                  handleSubmit()
                  setTimeout(() => setSubmitting(false), 500)
                }}
                disabled={isSubmitting}
                className="btn btn-primary btn-elevate"
              >
                {isSubmitting ?
                  <div className="d-flex align-items-center">
                    <div className="mr-2">Loading...</div>
                    <div className="spinner spinner-white mr-10"></div>
                  </div> : "Save"}
              </button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </>
  );
}

export function ClientEditModal(props) {
  return (
    <>
      <Modal show={props.show} onHide={props.handleClose} size="lg">
        <Modal.Header>
          <h1>{props.client.uid ? "Edit User" : "New User"}</h1>
        </Modal.Header>

        <ClientEditForm {...props} />
      </Modal>
    </>
  );
}
export function ClienDeleteModal(props) {
  return (
    <>
      <Modal
        show={props.delete}
        onHide={props.hideDelete}
        dialogClassName="p-5"
      >
        <Modal.Header>
          <h1>Delete User</h1>
        </Modal.Header>
        <Modal.Body>
          Are you sure to permanently delete this <b>user</b>?
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            onClick={props.hideDelete}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="submit"
            onClick={() => props.deleteClient(props.client.uid)}
            className="btn btn-danger btn-elevate"
          >
            Delete
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
